const comments = [
  {
    name: '追剧小达人',
    time: '2小时前',
    content: '人人影视真的太强了！不缓冲秒播不是吹的，用4G看1080P完全不卡。最让我惊喜的是更新速度，海外剧比别的平台快太多了，字幕质量也很高。已经推荐给身边所有追剧的朋友了。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20avatar%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20simple%20warm%20background%2C%20clean%20headshot%2C%20professional%20look&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '电影爱好者阿明',
    time: '5小时前',
    content: '用了三年了，资源全、画质好、不用注册直接看。以前在别的平台各种充会员，自从发现人人影视高清免费在线观看，再也没花过冤枉钱。希望平台越做越好，会一直支持下去。',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20avatar%20portrait%2C%20warm%20smile%2C%20everyday%20style%2C%20simple%20neutral%20background%2C%20clean%20headshot%2C%20friendly%20look&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '深夜追剧人',
    time: '8小时前',
    content: '作为一个夜班族，深夜追剧是唯一的消遣。人人影视的夜间模式很贴心，画质自适应也很智能。纪录片频道资源越来越丰富了，最近在看地球脉动亚洲篇，4K画质震撼到我了。',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20avatar%20portrait%2C%20gentle%20smile%2C%20modern%20style%2C%20simple%20warm%20background%2C%20clean%20headshot%2C%20friendly%20professional%20look&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section
      id="comments"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100 scroll-mt-16"
    >
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          观众热评
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="p-5 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}